import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=1a6da9e1"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/daiichisekiyu-mini-app/Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__